import { createContext } from 'react';
import NotificationService from '../_redux/services/notifications/notifications.service';

type Props = {
  notificationService: NotificationService | undefined;
};
const NotificationContext = createContext<Props>(undefined);

export default NotificationContext;
